<p-field [label]="label" [isReadOnly]="true" [ngClass]="{'comment-field': value?.text}">
    <div slot="readMode" class="comment">
        <div class="comment-details">
            <ng-container *ngIf="value?.createdBy as createdBy">
                <span class="created-by" [matTooltip]="createdBy!.toString()" [showOnlyWhenEllipsis]="true">{{ createdBy }}</span>
            </ng-container>
            <span class="date" *ngIf="value?.date">{{ removePrefix(value?.date | distanceFromNow) }}</span>
        </div>
        <div #commentField *ngIf="value?.text" [ngClass]="commentClass" class="comment-text">
            <ng-container *ngFor="let item of commentContent">
                <span *ngIf="item.type === 'regular'; else chip" class="p-paragraph-1">{{ item.value }}</span>
                <ng-template #chip>
                    <span class="mentioned-label p-paragraph-1"> {{ item.value }} </span>
                </ng-template>
            </ng-container>
        </div>
        <p-link *ngIf="isTextOverflows && !isExpanded" (onClick)="expandElement()">
            {{ 'Requirements.codeCorrectionSideBar.essentialSection.readMore' | translate }}
        </p-link>
        <p-link *ngIf="isExpanded && isTextOverflows" (onClick)="openInNewTab()">
            {{ 'Requirements.codeCorrectionSideBar.essentialSection.openInTab' | translate }}
        </p-link>
        <p-action-button
            (buttonClicked)="actionClick.emit($event)"
            iconBeforeName="plus"
            [label]="actionText | translate"
        ></p-action-button>
    </div>
</p-field>
